import jsonLd from './functions/_jsonLd'
import blogArticle from './functions/blogArticle'

export default function JsonLdBlogArticle ({ article }) {
    return article
        ? jsonLd(blogArticle(article))
        : null
}